import React from 'react';
import Button from 'react-bootstrap/Button';

// Individual suggestions in PromptSuggestions component of the AI Art expedition page

// Clicking on these buttons will add the word displayed on the button to the prompt box

const SuggestionWord = ({ children }) => {
    return (
        <Button className="mr-3" variant='outline-info'  style={{ margin: '5px 5px' }} onClick={() => {
            const prompt = document.getElementById('prompt');
            prompt.value = prompt.value + ' ' + children;
        }} id={children}>
            {React.Children.map(children, child => (
                child
            ))}
        </Button>
    );
};

export default SuggestionWord;